module.exports = __webpack_public_path__ + "img/go-tyan.0fe28d72.svg";